import rimg from '@pixelunion/rimg-shopify'; // eslint-disable-line
import AsyncView from '@pixelunion/shopify-asyncview';

import ProductMasonry from '../components/ProductMasonry';

export default class StaticProductRecommendations {
  constructor(section) {
    this.data = section.data;

    this._init();

    this.recommendUrl = `${window.Theme.routes.product_recommendations_url}?section_id=${section.id}&product_id=${this.productId}`;

    this._reloadRecommendations = this._reloadRecommendations.bind(this);
    window.addEventListener('shopify:section:load', this._reloadRecommendations);

    this._loadRecommendations();
  }

  _init() {
    this.productId = this.data.productId;
    this.positionedRight = this.data.positionRight;
    this.productSectionEl = document.querySelector('[data-section-type="product"]');
    this.productSectionIsPresent = !!this.productSectionEl;
    let productSectionData;


    // The product section can be hidden so we default to using the 'standard'
    // recommended products section (the one that's not right-aligned).
    if (this.productSectionIsPresent) {
      productSectionData = JSON.parse(this.productSectionEl.innerHTML);
      this.use_masonry = productSectionData.images_layout === 'masonry';

      this.productContainerEl = document.querySelector('.product-container');
      this.productContainerEl.classList.add(`product-recommendations-position-${this.positionedRight ? 'right' : 'section'}`);

      this.rightRecommendationContainer = document.querySelector('[data-product-recommendations-right]');
      this.rightRecommendationContainer.innerHTML = '';
    } else {
      this.use_masonry = false;
    }

    if (this.use_masonry || !this.productSectionIsPresent) {
      this.positionedRight = false;
    }

    this.sectionRecommendationContainer = document.querySelector('[data-product-recommendations-section]');
  }

  _loadRecommendations() {
    AsyncView.load(
      this.recommendUrl,
      { view: '' },
    ).then(response => {
      if (!response) return;

      const { html } = response;
      if (!html.common) {
        return;
      }
      const tempContainer = document.createElement('div');
      tempContainer.innerHTML = html.common;
      const productsWrapper = tempContainer.querySelector('.product-recommendations');

      if (!this.positionedRight || this.use_masonry) {
        productsWrapper.innerHTML = html.below;
      } else {
        productsWrapper.innerHTML = html.right;
      }

      if (this.use_masonry) {
        productsWrapper.classList.remove('row-of-4');
        productsWrapper.classList.add('row-of-3');
      } else {
        // Remove extra products for non-masonry layouts
        productsWrapper
          .querySelectorAll('[data-masonry-only]')
          .forEach(product => product.parentNode.removeChild(product));
      }

      if (this.positionedRight) {
        this.rightRecommendationContainer.innerHTML = tempContainer.innerHTML;
      } else {
        this.sectionRecommendationContainer.innerHTML = tempContainer.innerHTML;
      }

      if (this.use_masonry) {
        this.productMasonry = new ProductMasonry({ el: this.sectionRecommendationContainer });
      }

      let productItems;

      if (this.positionedRight) {
        rimg.watch(this.rightRecommendationContainer);
        productItems = this.rightRecommendationContainer.querySelectorAll('.product-list-item');
      } else {
        rimg.watch(this.sectionRecommendationContainer);
        productItems = this.sectionRecommendationContainer.querySelectorAll('.product-list-item');
      }

      if (productItems.length) {
        if (window.Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }
      }
    });
  }

  // This method is only called inside of the theme editor
  // when the user changes product section settings
  _reloadRecommendations() {
    this._init();
    this._loadRecommendations();
  }

  onSectionUnload() {
    if (this.productMasonry) {
      this.productMasonry.onSectionUnload();
    }

    this.productContainerEl.classList.remove(`product-recommendations-position-${this.positionedRight ? 'right' : 'section'}}`);
    this.rightRecommendationContainer.innerHTML = '';
    this.sectionRecommendationContainer.innerHTML = '';
    window.removeEventListener('shopify:section:load', this._reloadRecommendations);
  }
}
